import React from 'react';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';

function Cookie() {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={3}>Cookie Policy</Typography>
      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
          <Typography variant="caption" color="text.secondary" display="block" mb={3}>Last update: January 2025</Typography>
          
          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>Cookies and Tracking Tools</Typography>
          <Typography paragraph>
            The Platform uses proprietary cookies and tracking tools, including image pixels, strictly necessary for the operation of the conversion attribution service.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>Purpose and Characteristics</Typography>
          <Typography paragraph>These tools:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography>Are not used for marketing or profiling purposes</Typography></li>
            <li><Typography>Do not allow direct identification of end users</Typography></li>
            <li><Typography>Are accessible exclusively by Digitoo</Typography></li>
          </Box>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>Acceptance</Typography>
          <Typography paragraph>
            Use of the Platform implies the installation of these tools as they are necessary for the provision of the service.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>Technical Cookies Used</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography><strong>Session cookies:</strong> Essential for Platform operation and user authentication</Typography></li>
            <li><Typography><strong>Tracking pixels:</strong> 1x1 transparent images used for conversion attribution</Typography></li>
            <li><Typography><strong>Click identifiers:</strong> Unique IDs to track the customer journey from click to conversion</Typography></li>
          </Box>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>Data Retention</Typography>
          <Typography paragraph>
            Cookies and tracking data are retained for the time strictly necessary to fulfill the purposes described above, and in any case for no longer than 24 months.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>Contact</Typography>
          <Typography paragraph>
            For any questions regarding cookies and tracking tools, please contact: info@digitoogroup.com
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Cookie;
